import {NgModule} from "@angular/core";
import {NgChartsCommonModule} from "./common/ng-charts-common.module";
import {NgPieChartModule} from "./pie-chart/ng-pie-chart.module";
import {NgLineChartModule} from "./line-chart/ng-line-chart.module";
import {NgGaugeModule} from "./gauge/ng-gauge.module";
import {NgBarChartModule} from "./bar-chart/index";

// https://github.com/swimlane/ngx-charts/tree/6e0d63eda8c62b1c85b49b658e3d6576c34ef429
@NgModule({
    imports: [
    ],
    exports: [
        NgChartsCommonModule,
        NgLineChartModule,
        NgPieChartModule,
        NgBarChartModule,
        NgGaugeModule
    ]
})
export class NgChartsModule {
}

